import { cva } from 'class-variance-authority';

export const typographyVariants = cva('', {
  variants: {
    variant: {
      // Headings
      h1: `
        scroll-m-20 text-4xl font-extrabold tracking-tight
        lg:text-5xl
      `,
      h2: `
        mt-10 scroll-m-20 border-b pb-2 text-3xl font-semibold tracking-tight
        transition-colors
        first:mt-0
      `,
      h3: 'mt-8 scroll-m-20 text-2xl font-semibold tracking-tight',
      h4: 'mt-8 scroll-m-20 text-xl font-semibold tracking-tight',
      h5: 'mt-8 scroll-m-20 text-lg font-semibold tracking-tight',
      h6: 'mt-8 scroll-m-20 text-base font-semibold tracking-tight',

      // Body text
      p: `
        leading-7
        [&:not(:first-child)]:mt-6
      `,
      lead: 'text-xl text-neutral-500',
      large: 'text-lg font-semibold',
      small: 'text-sm leading-none font-medium',
      muted: 'text-sm text-neutral-500',

      // Special formats
      blockquote: 'mt-6 border-l-2 pl-6 text-neutral-600 italic',
      code: `
        relative rounded bg-neutral-100 px-[0.3rem] py-[0.2rem] font-mono
        text-sm font-semibold text-neutral-900
      `,
      pre: `
        mt-6 mb-4 overflow-x-auto rounded-lg bg-neutral-900 p-4 text-neutral-50
      `,

      // Lists
      ul: `
        my-6 ml-6 list-disc
        [&>li]:mt-2
      `,
      ol: `
        my-6 ml-6 list-decimal
        [&>li]:mt-2
      `,
      li: 'mt-2',

      // Inline elements
      strong: 'font-semibold',
      em: 'italic',
      mark: 'bg-yellow-100 px-1 text-neutral-900',
      del: 'line-through',
      ins: 'underline',
      sub: 'sub text-xs',
      sup: 'sup text-xs',
      kbd: `
        rounded border border-neutral-200 bg-neutral-100 px-1 py-0.5 font-mono
        text-xs text-neutral-900
      `,

      // Table elements
      table: 'w-full',
      thead: '[&_tr]:border-b',
      tbody: '[&_tr:last-child]:border-0',
      tfoot: `
        border-t bg-neutral-50 font-medium
        [&>tr]:last:border-b-0
      `,
      tr: `
        border-b transition-colors
        hover:bg-neutral-50/50
        data-[state=selected]:bg-neutral-100
      `,
      th: `
        h-12 px-4 text-left align-middle font-medium text-neutral-500
        [&:has([role=checkbox])]:pr-0
      `,
      td: `
        p-4 align-middle
        [&:has([role=checkbox])]:pr-0
      `,
    },
    color: {
      default: '',
      primary: 'text-primary-600',
      secondary: 'text-secondary-600',
      muted: 'text-neutral-500',
      danger: 'text-semantic-red-500',
      warning: 'text-semantic-yellow-600',
      success: 'text-semantic-green-600',
      info: 'text-semantic-blue-700',
    },
    align: {
      default: '',
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
      justify: 'text-justify',
    },
    weight: {
      default: '',
      thin: 'font-thin',
      extralight: 'font-extralight',
      light: 'font-light',
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
      extrabold: 'font-extrabold',
      black: 'font-black',
    },
    size: {
      default: '',
      xs: 'text-xs',
      sm: 'text-sm',
      base: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
      '4xl': 'text-4xl',
      '5xl': 'text-5xl',
      '6xl': 'text-6xl',
      '7xl': 'text-7xl',
      '8xl': 'text-8xl',
      '9xl': 'text-9xl',
    },
  },
  defaultVariants: {
    variant: 'p',
    color: 'default',
    align: 'default',
    weight: 'default',
    size: 'default',
  },
});
